import { Blog, getStaticProps } from 'routes/public/Blog'

export { getStaticProps }

export default Blog
